import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { defineComponent, ref } from "vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import Head from "@/components/Head/index.vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

import { saveAs } from "@/hooks/downUrl";
import MeetingDetail from "./components/Detail.vue";
export default defineComponent({
  name: "MeetingSignUp",
  components: {
    Head: Head,
    MeetingDetail: MeetingDetail
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var route = useRoute();
    var router = useRouter();
    var detail = ref({});
    var showAttachment = ref("暂无附件");
    var attachmentId = ref(0);
    var count = ref(0);
    var id = route.query.id;

    function getMeetingDetail() {
      return _getMeetingDetail.apply(this, arguments);
    } //根据附件id获取附件名


    function _getMeetingDetail() {
      _getMeetingDetail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$globalProperti, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getMeetingDetail"](id);

              case 2:
                _yield$globalProperti = _context.sent;
                data = _yield$globalProperti.data;
                detail.value = data;

                if (data.attachment != "") {
                  getFileNameById(data.attachment);
                } else {
                  showAttachment.value = "暂无附件";
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getMeetingDetail.apply(this, arguments);
    }

    function getFileNameById(_x) {
      return _getFileNameById.apply(this, arguments);
    } //下载附件


    function _getFileNameById() {
      _getFileNameById = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
        var data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getFileNameById"](id);

              case 2:
                data = _context2.sent;
                showAttachment.value = data.data.realName;
                attachmentId.value = data.data.attachmentId;

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _getFileNameById.apply(this, arguments);
    }

    function downFile() {
      saveAs(attachmentId.value);
    }

    function getSignUpPer() {
      return _getSignUpPer.apply(this, arguments);
    }

    function _getSignUpPer() {
      _getSignUpPer = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getSignUpPer"]({
                  meetingId: id
                });

              case 2:
                data = _context3.sent;

                if (data.code == 0) {
                  count.value = data.data;
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _getSignUpPer.apply(this, arguments);
    }

    function handleAudit() {
      return _handleAudit.apply(this, arguments);
    }

    function _handleAudit() {
      _handleAudit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _yield$globalProperti2, code;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getSignUpGo"](id);

              case 2:
                _yield$globalProperti2 = _context4.sent;
                code = _yield$globalProperti2.code;

                if (code == 0) {
                  ElMessage.success("\u62A5\u540D\u6210\u529F");
                  setTimeout(function () {
                    router.push({
                      path: "/personal/meeting"
                    });
                  }, 500);
                }

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return _handleAudit.apply(this, arguments);
    }

    getMeetingDetail();
    getSignUpPer();
    return {
      detail: detail,
      handleAudit: handleAudit,
      showAttachment: showAttachment,
      attachmentId: attachmentId,
      getFileNameById: getFileNameById,
      downFile: downFile,
      count: count,
      getSignUpPer: getSignUpPer
    };
  }
});